import React from "react"
import imageJoinTheTeam from "images/join-the-team.png"
import imageChooseYourFavorite from "images/choose-your-favorite.png"
import imageEatAndEnjoy from "images/eat-and-enjoy.png"
import Slider from "react-slick";


const lunchmadesimple = (props) => {
  var settings = {
      speed: 500,
      responsive: [
        {
          breakpoint: 5000,
          settings: 'unslick'
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  };
  return (
    <div ref={props.howItWorksRef} className="secao-3-2">
      <div className="wrap">
        <h1>Lunch Made Simple</h1>
        <div className="columns">
          <div className="col left wow animated bounceInLeft">
            <img alt="join the team" src={imageJoinTheTeam} />
            <span>Join the Team</span>
            <p>
              Everyone creates their own individual account by entering their
              email in the Order Now box, hitting return and following the set
              up instructions.
            </p>
          </div>
          <div className="col left wow animated bounceInDown">
            <img alt="choose your favorite" src={imageChooseYourFavorite} />
            <span>Choose Your Favorite</span>
            <p>
              They choose their lunch their way from any of the fabulous
              restaurants on display, charging to their card or to account if
              the boss is feeling generous.
            </p>
          </div>
          <div className="col left wow animated bounceInRight">
            <img alt="eat and enjoy" src={imageEatAndEnjoy} />
            <span>Eat and Enjoy</span>
            <p>
              Food will then be delivered to the agreed drop off location by the
              agreed time, individually bagged and labelled, with an email
              notification sent on arrival.
            </p>
          </div>
        </div>
        <Slider className="lunch-made-simple-mobile" {...settings}>
          <div>
            <img alt="join the team" src={imageJoinTheTeam} />
            <span>Join the Team</span>
            <p>
              Everyone creates their own individual account by entering their
              email in the Order Now box, hitting return and following the set
              up instructions.
            </p>
          </div>
          <div>
            <img alt="choose your favorite" src={imageChooseYourFavorite} />
            <span>Choose Your Favorite</span>
            <p>
              They choose their lunch their way from any of the fabulous
              restaurants on display, charging to their card or to account if
              the boss is feeling generous.
            </p>
          </div>
          <div>
            <img alt="eat and enjoy" src={imageEatAndEnjoy} />
            <span>Eat and Enjoy</span>
            <p>
              Food will then be delivered to the agreed drop off location by the
              agreed time, individually bagged and labelled, with an email
              notification sent on arrival.
            </p>
          </div>
        </Slider>
        <a onClick={props.HandleFindOutMore} className="bt get-more-info">Find out more</a>
      </div>
    </div>
  )
}

export default lunchmadesimple



// WEBPACK FOOTER //
// ./src/containers/Landing/LunchMadeSimple/index.js